export default __webpack_public_path__ + "static/media/CERP.92e4465e.png";